import { motion } from 'framer-motion';
import { useSignupConfig } from 'src/features/register/hooks/useSignupConfig';
import RegisterForm from 'src/features/register/ui/RegisterForm';
import { Logo } from 'src/shared/components';
import { useMetaPixel, usePageTitle } from 'src/shared/hooks';

const RegisterPage = () => {
  const { data: signupConfig, isLoading } = useSignupConfig();
  const openSignUp = signupConfig?.open_sign_up ?? false;

  usePageTitle('Register | Cavela');
  useMetaPixel('989168503310664');

  return (
    <div className="bg-background">
      <div className="bg-white min-h-dvh flex flex-col">
        <div className="grid-cols-2 md:grid flex h-full flex-1 w-full">
          <div className="relative w-full p-10">
            {isLoading ? null : (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ ease: 'easeInOut', duration: 0.6 }}
                className="w-full md:max-w-lg md:mx-auto flex flex-col justify-center h-full"
              >
                <div className="h-8">
                  <Logo />
                </div>

                <RegisterForm openSignUp={openSignUp} />
              </motion.div>
            )}
          </div>

          <div
            className="hidden items-center justify-center md:flex"
            style={{
              background: 'url(/backgrounds/registerBgGreen.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <motion.img
              initial={{ y: 24, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ ease: 'easeInOut', duration: 1 }}
              draggable="false"
              className="w-[60%]"
              alt="ipad"
              src="/backgrounds/register-hero.png"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
